import React, { useState } from "react";
import { Form } from "react-bootstrap";
// import { FieldProps } from "formik";
import { Tabs, Tab } from "react-bootstrap";
import ReactQuill from "react-quill";
import "./quill.scss";
import { injectIntl} from "react-intl";

// import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const RichText = ({
  field: { name, value, ...fields },
  form: { touched, errors, setFieldValue },
  intl,
  ...props
}) => {
  const [editing, setEditing] = useState("rich");
  const [text, setText] = React.useState(value);
  const handleChange = (value) => {
    setText(value);
    setFieldValue(name, value);
  };
  var toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    // ['blockquote', 'code-block'],

    // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    // [{ 'font': [] }],
    [{ 'align': [] }],

    ["clean"], // remove formatting button
  ];

  // useEffect(() => {
  //   if (value !== rteValue.toString("html")) {
  //     setRteValue(RichTextEditor.createValueFromString(value, "html"));
  //   }
  // }, [setRteValue, rteValue, value]);

  return (
    <Form.Group controlId={name}>
      {props.label && (
        <Form.Label>
          {props.required ? <b>{props.label}</b> : props.label}
          {props.required && <span className="text-danger">*</span>}
        </Form.Label>
      )}
      <Tabs
        id="tabs-with-dropdown"
        activeKey={editing}
        onSelect={(k) => {
          setEditing(k);
        }}
      >
        <Tab eventKey="rich" title={intl.formatMessage({id:'rich.text'})}>
          <ReactQuill
            placeholder={props.placeholder}
            value={text}
            modules={{
              toolbar: toolbarOptions,
            }}
            onChange={handleChange}
            className="rte-editor"
          />
        </Tab>
        <Tab eventKey="html" title="HTML">
          <div className="form-group">
            <textarea
              className="form-control"
              value={value}
              placeholder={props.placeholder}
              onChange={(e) => {
                // TODO
                setText(
                  e.target.value
                );
                setFieldValue(name, e.target.value);
              }}
              rows={14}
            />
          </div>
        </Tab>
      </Tabs>
      <Form.Control.Feedback type="invalid">
        {errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default injectIntl(RichText);
